import { useDispatch, useSelector } from 'react-redux'
import { MailboxDispatch, RootState } from './types'

export const useMailboxDispatch = () => useDispatch<MailboxDispatch>()
export const useMailboxSelector = useSelector.withTypes<RootState>()
